import { createApi } from '@reduxjs/toolkit/query/react';
import { webApiResponseBaseQuery } from '../webApiResponseBaseQuery';

export const tradesApi = createApi({
  reducerPath: 'tradesApi',
  baseQuery: webApiResponseBaseQuery,
  endpoints: (builder) => ({
    closedDates: builder.query<Record<string, string>, string>({
      query: (currencyPair) => ({
        url: 'myfx/dates/closed',
        method: 'POST',
        body: [currencyPair],
      }),
    }),
  }),
});

export const { useClosedDatesQuery } = tradesApi;
